module.exports = __webpack_public_path__ + "static/media/no_data_2.35153326.png";